/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { TimeAndMaterialsContractDetailsRequest } from './';
import {
    TimeAndMaterialsContractDetailsRequestFromJSON,
    TimeAndMaterialsContractDetailsRequestFromJSONTyped,
    TimeAndMaterialsContractDetailsRequestToJSON,
} from './';
import type { UpdateContractRequest } from './';
import {
    UpdateContractRequestFromJSON,
    UpdateContractRequestFromJSONTyped,
    UpdateContractRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateTimeAndMaterialsContractRequest
 */
export interface UpdateTimeAndMaterialsContractRequest extends UpdateContractRequest {
    /**
     * 
     * @type {TimeAndMaterialsContractDetailsRequest}
     * @memberof UpdateTimeAndMaterialsContractRequest
     */
    details: TimeAndMaterialsContractDetailsRequest;
}

/**
 * Check if a given object implements the UpdateTimeAndMaterialsContractRequest interface.
 */
export function instanceOfUpdateTimeAndMaterialsContractRequest(value: object): value is UpdateTimeAndMaterialsContractRequest {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function UpdateTimeAndMaterialsContractRequestFromJSON(json: any): UpdateTimeAndMaterialsContractRequest {
    return UpdateTimeAndMaterialsContractRequestFromJSONTyped(json, false);
}

export function UpdateTimeAndMaterialsContractRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimeAndMaterialsContractRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdateContractRequestFromJSONTyped(json, ignoreDiscriminator),
        'details': TimeAndMaterialsContractDetailsRequestFromJSON(json['details']),
    };
}

export function UpdateTimeAndMaterialsContractRequestToJSON(value?: UpdateTimeAndMaterialsContractRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdateContractRequestToJSON(value, true),
        'details': TimeAndMaterialsContractDetailsRequestToJSON(value['details']),
    };
}

